import React from "react";
import {
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Box,
  Typography,
} from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

import Dialog from "../Dialog";
import Button from "../Button";

import { IButtonVariant } from "@/models/button";

const PaymentRetryDialog = ({
  open,
  onClose,
  onRetry,
  errorMessage,
  isProcessing,
}) => {
  return (
    <Dialog isOpen={open} closeHandler={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box display="flex" alignItems="center">
          <ErrorOutlineIcon color="error" sx={{ fontSize: 30, mr: 2 }} />
          <Typography variant="h6">Payment Failed</Typography>
        </Box>
      </DialogTitle>

      <DialogContent>
        <DialogContentText>
          {errorMessage || "Your payment could not be processed."}
        </DialogContentText>

        <Box mt={2}>
          <Typography variant="body2" color="text.secondary">
            Possible reasons:
          </Typography>
          <ul>
            <li>Insufficient funds</li>
            <li>Incorrect card details</li>
            <li>Network issues</li>
            <li>Bank declined the transaction</li>
          </ul>
        </Box>
      </DialogContent>

      <DialogActions
        sx={{
          p: 3,
          "& > button": { width: "max-content", padding: "0rem 2rem" },
        }}
      >
        <Button
          variant={IButtonVariant.WHITE}
          btnTrigger={onClose}
          disabled={isProcessing}
        >
          Close
        </Button>
        <Button
          btnTrigger={onRetry}
          disabled={isProcessing}
          isLoading={isProcessing}
        >
          {isProcessing ? "Processing..." : "Retry Payment"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PaymentRetryDialog;
